import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=b48a680e&scoped=true"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=b48a680e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48a680e",
  null
  
)

export default component.exports